import { formatTime } from '../../filter'
import cloneDeep from 'lodash/cloneDeep'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let applyCancels = cloneDeep(order.applyCancels)
	if (!applyCancels || !applyCancels.length || applyCancels.length === 1) {
		return false
	}
	const index = applyCancels.findIndex(item => item.dataType === 'application')
	if (index > -1) {
		applyCancels.splice(index, 1)
	}
	let arr = []

	if (applyCancels) {
		for (const item of applyCancels) {
			const obj = {}
			if (item.dataType === 'application') {
				obj.title = '撤单审核申请'
				if (item.type === '2') {
					obj.children = [
						{
							label: '撤单发起时间',
							value: formatTime(item.createTime),
						},
						{
							label: '撤单状态',
							value: setting.cancelTypeMap[item.type],
						},
						{
							label: '现场位置',
							value: item.address,
						},
						{
							label: '申请原因',
							value: item.reason,
						},
						{
							label: '撤单申请提交照片',
							slot: 'image',
							value: item.mediaInfoList,
						},
					]
				} else {
					obj.children = [
						{
							label: '撤单发起时间',
							value: formatTime(item.createTime),
						},
						{
							label: '撤单状态',
							value: setting.cancelTypeMap[item.type],
						},
						{
							label: '申请原因',
							value: item.reason,
						},
					]
				}
			} else {
				if (item.auditResult === '0') {
					obj.title = '撤单审核通过'
					obj.children = [
						{
							label: '审核通过时间',
							value: formatTime(item.createTime),
						},
						{
							label: '审核通过人员',
							value: item.auditorName,
						},
					]
				} else {
					obj.title = '撤单审核退回'
					obj.children = [
						{
							label: '审核退回时间',
							value: formatTime(item.createTime),
						},
						{
							label: '审核退回人员',
							value: item.auditorName,
						},
						{
							label: '审核退回原因',
							value: item.reason,
						},
					]
				}
			}
			arr.push(obj)
		}
	}

	return {
		title: '撤单历史记录',
		children: arr,
	}
}
